const SCROLL = {
  MOBILE_TOP_OFFSET: 30,
  DESKTOP_TOP_OFFSET: 150,
  SIMPLE_ACCORDION_TOP_OFFSET: 200,
};

export default SCROLL;



// WEBPACK FOOTER //
// ./src/common/consts/scroll.js